import { waitForOptimizelyValueUsingMutationObserver } from './optimizely-activation-observer';

export function triggerOptimizelyActivation(optimizelyId: string) {
    if (typeof window !== 'undefined' && optimizelyId) {
        waitForOptimizelyValueUsingMutationObserver(() => {
            (window as any).optimizely = (window as any).optimizely || [];
            (window as any).optimizely.push({
                type: 'activate',
            });
        });
    }
}
